import {ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {DefaultApi} from '../service/default.api';
import {User} from '../model/User';
import {Router} from '@angular/router';
import {MatCard} from '@angular/material/card';

@Component({
    selector: 'app-accept-cookie',
    templateUrl: './accept-cookie.component.html',
    standalone: false
})
export class AcceptCookieComponent implements OnInit {
  @ViewChildren(ImageBitmap) matCardQueryList: QueryList<MatCard>;
  user: User;
  loading = true;
  checked: any;
  managers: User[];
  imageIndexList: number[] = [];
  constructor(private api: DefaultApi, private cd: ChangeDetectorRef,
              private router: Router) { }
  ngOnInit(): void {
    this.api.getUserInfo().subscribe(value => {
      this.user = new User({
        userId: value.id,
        userEmail: value.userEmail,
        userLastName: value.userLastName,
        userName: value.userName,
        userPhoneNumber: value.userPhoneNumber,
        hasPhoto: value.hasPhoto
      });
      this.api.getManagers(this.user.userId).subscribe(_managers => {
        this.managers = _managers;
        for (let i = 0; i < 8; i++) {
          this.imageIndexList.push(1 + Math.floor(Math.random() * Math.floor(8)));
        }
      });
      this.loading = false;
    });
  }

  onAcceptCookieClick() {
    this.api.acceptCookie().subscribe(() => {
      this.router.navigate(['selectPortal']);
    });
  }

  getUserPhotoId(): number {
    console.log('getUserPhotoId');
    this.matCardQueryList.changes.subscribe(() => {
      this.cd.detectChanges();
    });
    return  Math.floor(Math.random() * Math.floor(4));
  }
}
